import { render, staticRenderFns } from "./disable2FAModal.vue?vue&type=template&id=19548b05&scoped=true"
import script from "./disable2FAModal.vue?vue&type=script&lang=js"
export * from "./disable2FAModal.vue?vue&type=script&lang=js"
import style0 from "./disable2FAModal.vue?vue&type=style&index=0&id=19548b05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19548b05",
  null
  
)

export default component.exports